<template>
  <div class="d-grid">
    <shifts-form v-if="shiftsFormOpen" :initial-selected-shift-ids="[]"
                 :submit-button-label="i18n.t('buttons.i_am_going')" @submit="saveShifts" />

    <light-button v-else type="button" :label="i18n.t('events.show.update_to_attending')"
                  class="change-button btn-small btn-with-break-lines" @click="changeToAttending" />
  </div>
</template>

<script>
import { ATTENDING } from './attending-statuses'
import LightButton from '@/components/buttons/light-button'
import { mapActions, mapGetters } from 'vuex'
import ShiftsForm from './shifts-form'

export default {
  components: { LightButton, ShiftsForm },

  data() {
    return {
      shiftsFormOpen: false
    }
  },

  computed: {
    ...mapGetters(['shiftedEvent'])
  },

  methods: {
    ...mapActions(['updateAttendee']),

    changeToAttending() {
      if (this.shiftedEvent) {
        this.openShiftsForm()
      } else {
        this.updateAttendee({ attendingStatus: ATTENDING })
      }
    },

    openShiftsForm() {
      this.shiftsFormOpen = true
    },

    saveShifts(selectedShiftIds) {
      this.updateAttendee({ attendingStatus: ATTENDING, shiftIds: selectedShiftIds })
    }
  }
}
</script>

<style lang="scss" scoped>
.change-button {
  text-transform: unset;
}
</style>
